import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import LibraryBooks from '@material-ui/icons/LibraryBooks';
import Subtitles from '@material-ui/icons/Subtitles';
import PeopleIcon from '@material-ui/icons/People';
import LoyaltyIcon from '@material-ui/icons/Loyalty'
import Book from '@material-ui/icons/Book';

import { Route, Switch } from 'react-router-dom';
import { Link } from 'react-router-dom';

import Department from '../components/Settings/Department/Department';
import Subject from '../components/Settings/Subject/Subject';
import Course from '../components/Settings/Course/Course';
import Register from '../components/Settings/Register/Register';

import image from "../assets/img/sidebar-2.jpg";

import UserManager from './userManager'
import News from '../components/Settings/News/News';

const drawerWidth = 240;

const styles = theme => ({
    root: {
        display: 'flex',
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginLeft: 12,
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing.unit * 7,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing.unit * 9,
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        paddingTop: 90,
        padding: theme.spacing.unit * 3,
        height: '100vh',
        overflow: 'auto',
    },
    chartContainer: {
        marginLeft: -22,
    },
    tableContainer: {
        height: 320,
    },
    h5: {
        marginBottom: theme.spacing.unit * 2,
    },
});

class settings extends React.Component {
    state = {
        open: true,
    };

    handleDrawerOpen = () => {
        this.setState({ open: true });
    };

    handleDrawerClose = () => {
        this.setState({ open: !this.state.open });
    };

    render() {
        const { classes } = this.props;

        return (
            <main>
                <div className={classes.root}>
                    <CssBaseline />
                    <Drawer style={{ paddingTop: 74 }}
                        variant="permanent"
                        classes={{
                            paper: classNames(classes.drawerPaper, !this.state.open && classes.drawerPaperClose),
                        }}
                        open={this.state.open}
                    >
                        {/* <div className={classes.toolbarIcon}>
            <IconButton onClick={this.handleDrawerClose}>
              <ChevronLeftIcon />
            </IconButton>
          </div> */}
                        <Divider />
                        <div className="sidebar-wrapper" style={{ paddingTop: 20 }}>
                            <ListSubheader inset style={{ color: '#b4adad' }}>จัดการวิชา</ListSubheader>
                            <Link to="/settings/department" style={{ textDecoration: 'none', color: '#fff' }}>
                                <ListItem button>
                                    <ListItemIcon style={{ color: '#b4adad' }}>
                                        <LibraryBooks />
                                    </ListItemIcon>
                                    <ListItemText primary={
                                        <Typography type="body2" style={{ color: '#b4adad' }}>
                                            กลุ่มวิชา
                                        </Typography>
                                    } />
                                </ListItem>
                            </Link>
                            <Link to="/settings/subject" style={{ textDecoration: 'none', color: 'black' }}>
                                <ListItem button>
                                    <ListItemIcon style={{ color: '#b4adad' }}>
                                        <Subtitles />
                                    </ListItemIcon>
                                    <ListItemText primary={
                                        <Typography type="body2" style={{ color: '#b4adad' }}>
                                            วิชา
                                        </Typography>
                                    } />
                                </ListItem>
                            </Link>
                            <Link to="/settings/course" style={{ textDecoration: 'none', color: 'black' }}>
                                <ListItem button>
                                    <ListItemIcon style={{ color: '#b4adad' }}>
                                        <Book />
                                    </ListItemIcon>
                                    <ListItemText primary={
                                        <Typography type="body2" style={{ color: '#b4adad' }}>
                                            คอร์สเรียน
                                        </Typography>
                                    } />
                                </ListItem>
                            </Link>
                            <br />
                            <Divider style={{ backgroundColor: '#545151'}} />
                            <ListSubheader inset style={{ color: '#b4adad' }}>จัดการผู้ใช้</ListSubheader>
                            <Link to="/settings/users" style={{ textDecoration: 'none', color: 'black' }}>
                                <ListItem button>
                                    <ListItemIcon style={{ color: '#b4adad' }}>
                                        <PeopleIcon />
                                    </ListItemIcon>
                                    <ListItemText primary={
                                        <Typography type="body2" style={{ color: '#b4adad' }}>
                                            ผู้ใช้งาน
                                        </Typography>
                                    } />
                                </ListItem>
                            </Link>
                            <br />
                            <Divider style={{ backgroundColor: '#545151'}} />
                            <ListSubheader inset style={{ color: '#b4adad' }}>ลงทะเบียน</ListSubheader>
                            <Link to="/settings/register" style={{ textDecoration: 'none', color: 'black' }}>
                                <ListItem button>
                                    <ListItemIcon style={{ color: '#b4adad' }}>
                                        <LoyaltyIcon />
                                    </ListItemIcon>
                                    <ListItemText primary={
                                        <Typography type="body2" style={{ color: '#b4adad' }}>
                                            จัดการการลงทะเบียน
                                        </Typography>
                                    } />
                                </ListItem>
                            </Link>
                            <Divider style={{ backgroundColor: '#545151'}} />
                            <ListSubheader inset style={{ color: '#b4adad' }}>ประกาศ</ListSubheader>
                            <Link to="/settings/news" style={{ textDecoration: 'none', color: 'black' }}>
                                <ListItem button>
                                    <ListItemIcon style={{ color: '#b4adad' }}>
                                        <LoyaltyIcon />
                                    </ListItemIcon>
                                    <ListItemText primary={
                                        <Typography type="body2" style={{ color: '#b4adad' }}>
                                            แก้ไขประกาศ
                                        </Typography>
                                    } />
                                </ListItem>
                            </Link>
                        </div>
                        <div
                            className="custom-background"
                            style={{ backgroundImage: `url(${image})` }}
                        />
                    </Drawer>
                    <main className={classes.content}>
                        {/* <div className={classes.appBarSpacer} /> */}
                        {/* <Department /> */}
                        <Switch>
                            <Route exact path="/settings" component={UserManager} />
                            <Route path="/settings/department" component={Department} />
                            <Route path="/settings/subject" component={Subject} />
                            <Route path="/settings/course" component={Course} />
                            <Route path="/settings/users" component={UserManager} />
                            <Route path="/settings/register" component={Register} />
                            <Route path="/settings/news" component={News} />
                        </Switch>
                    </main>
                </div>
            </main>
        );
    }
}

settings.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(settings);